import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import router from "./router";
import "./index.css";
import AllProvider from "./context";
import { ChakraProvider } from "@chakra-ui/react";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <ChakraProvider>
      <AllProvider>
        <RouterProvider router={router} />
      </AllProvider>
    </ChakraProvider>
  </React.StrictMode>
);
